var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.$isPrint,
          expression: "!$isPrint",
        },
      ],
      staticClass: "tab-block",
      style: {
        backgroundColor: _vm.$themeTokens.surface,
        borderBottom: `1px solid ${_vm.$themeTokens.fineLine}`,
      },
    },
    [
      _vm.topics.length && _vm.windowIsLarge
        ? _c(
            "router-link",
            {
              staticClass: "header-tab",
              class: _vm.defaultTabStyles,
              style: {
                color: _vm.$themeTokens.annotation,
                marginLeft: _vm.width > 234 ? "12px" : "0",
                marginRight: _vm.width > 234 ? "12px" : "0",
              },
              attrs: {
                to: _vm.foldersLink,
                activeClass: _vm.activeTabClasses,
                replace: true,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "inner",
                  style: { borderColor: _vm.$themeTokens.primary },
                  attrs: { "data-onboarding-id": "folders" },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.coreString("folders")) + "\n    "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.windowIsLarge
        ? _c(
            "router-link",
            {
              staticClass: "header-tab",
              class: _vm.defaultTabStyles,
              style: {
                color: _vm.$themeTokens.annotation,
                marginLeft: _vm.width > 234 ? "12px" : "0",
                marginRight: _vm.width > 234 ? "12px" : "0",
              },
              attrs: {
                to: _vm.topics.length ? _vm.searchTabLink : {},
                activeClass: _vm.activeTabClasses,
                replace: true,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "inner",
                  style: { borderColor: _vm.$themeTokens.primary },
                  attrs: { "data-onboarding-id": "search" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.coreString("searchLabel")) +
                      "\n    "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.tourActive && _vm.isTourActive("ExploreLibraries")
        ? _c("TooltipTour", {
            attrs: { page: "ExploreLibraries" },
            on: {
              tourEnded: function ($event) {
                return _vm.endTour("ExploreLibraries")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }